export enum DigitalSignageEndDateOptions {
  Never = "Never",
  Date = "Date"
}